module.exports = __webpack_public_path__ + "static/media/Avocado.92eeff9c.svg";